import { render, staticRenderFns } from "./PopularityDisplay.vue?vue&type=template&id=4b4cb2d0&scoped=true"
import script from "./PopularityDisplay.vue?vue&type=script&lang=js"
export * from "./PopularityDisplay.vue?vue&type=script&lang=js"
import style0 from "./PopularityDisplay.vue?vue&type=style&index=0&id=4b4cb2d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4cb2d0",
  null
  
)

export default component.exports